import { BusinessEntity } from '../../types';
import { TemplateComponent } from '../DocumentGenerator';

import { AddressComponent } from './address.template';

export type BusinessEntityTemplateType = {};

export const BusinessEntityComponent: TemplateComponent<
  BusinessEntity | undefined,
  BusinessEntityTemplateType,
  void,
  false,
  { customFieldsRoot: string }
> = {
  templatize: (businessEntity) => ({
    toString: () => businessEntity?.name ?? '',
    billingAddress: AddressComponent.templatize(businessEntity?.places?.[0]),
    customFields: businessEntity?.customFields,
  }),
  definitionMap: ({ customFieldsRoot }) => ({
    billingAddress: { label: 'Billing Address', type: 'address', children: AddressComponent.definitionMap },
    customFields: { label: 'Custom Fields', type: 'customFields', root: customFieldsRoot, section: 'businessEntity' },
  }),
};
